import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { Router } from '@angular/router';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { GlobalsService } from '../../services/globals.service';
import { ViasConnectionService, ViasResponse } from '../../services/vias-connection.service';
import { TranslateService } from '@ngx-translate/core';
import { AlertType, ViasReturnActions } from 'projects/viasng-core/src/public-api';

@Component({
  selector: 'vias-forgot',
  templateUrl: './forgot.component.html',
  styleUrls: ['./forgot.component.scss']
})
export class ForgotComponent implements OnInit {
  @ViewChild('errorTxt', { static: true }) errorTxt: ElementRef;

  public form: FormGroup;
  constructor(
    private fb: FormBuilder,
    private router: Router,
    public globals: GlobalsService,
    private viasService: ViasConnectionService,
    protected translate: TranslateService) {
    translate.use(globals.langLocale.substr(0, 2));
  }
  private email: string = '';
  ngOnInit(): void {
    this.globals.logout();
    this.form = this.fb.group({
      email: [null, Validators.compose([Validators.required, Validators.pattern('^([a-zA-Z0-9_\\-\\.]+)@([a-zA-Z0-9_\\-\\.]+)\\.([a-zA-Z]{2,5})$')])]
    });
  }

  sendMail(): void {
    if (this.form.valid) {
      console.log(this.form.value);
      this.viasService.send(0, 6, {
        email: this.form.value.email,
        firmId: this.globals.selectedFirmId
      }).then(
        r => {
          if (r.error !== null &&
            r.error !== undefined && r.error.length > 0
          ) {
            this.globals.handleErrors(r.error);
          } else if (r.return_action !== null &&
            r.return_action !== undefined && r.return_action.length > 0) {
            if ((r.return_action === ViasReturnActions.Success)) {
              this.globals.viasAlert.show('successful', AlertType.Success);
            }
          }
        },
        err => {
          alert(err);
          console.log(err);
        }
      );
    }
  }
  
  openLoginPage(): void {
    this.router.navigate(['/account/login']);
  }
}
